const isNZ = () => {
  return window.location.hostname.includes('nz');
};

export default isNZ;
